import { createSlice } from '@reduxjs/toolkit';
import { IInitialWidgetState } from './types';
import { options } from './constants';

const SLICE_NAME = 'WIDGET_SLICE';

export const initialState: IInitialWidgetState = {
  loading: false,
  error: '',
  data: {
    enabled: false,
    displayCorner: 'topLeft',
    iconUrl: '',
    accessibilityStatementUrl: '',
    hideIaLabsLogo: false,
    colors: {
      lightMode: '#5b5eff',
      darkmode: '',
    },
    options: options,
  },
  verifyLoading: false,
};

const userSlice = createSlice({
  name: SLICE_NAME,
  initialState: initialState,
  reducers: {
    fetchWidgetError: (state) => {
      state.loading = false;
      state.error = 'error';
    },
    fetchWidget: (state, { payload }) => {
      state.loading = true;
      state.error = '';
    },
    fetchWidgetSuccess: (state, { payload }) => {
      state.loading = false;
      state.data = payload;
    },
    saveWidgetData: (state, { payload }) => {
      state.error = '';
      state.loading = true;
      state;
    },
    saveWidgetDataSuccess: (state, { payload }) => {
      state.error = '';
      state.loading = false;
      state.data = payload;
    },
    addEnabledWidget: (state, { payload }) => {
      state.error = '';
      state.loading = true;
    },
    addEnabledWidgetSuccess: (state, { payload }) => {
      state.error = '';
      state.loading = false;
      state.data = payload;
    },
    setDefaultWidgetState: () => {
      return initialState;
    },
    verifyWidget: (state, { payload }) => {
      state.error = '';
      state.verifyLoading = true;
      // console.log('payload', payload);
    },
    verifyWidgetSuccess: (state, { payload }) => {
      state.error = '';
      state.verifyLoading = false;
      state.verify = payload;
    },
    verifyWidgetError: (state) => {
      state.error = 'error';
      state.verifyLoading = false;
    },
    cancelVerifyWidget: (state) => {
      state;
    },
  },
});

export default userSlice;
